import { createVoiceWatchdog } from './createVoiceWatchdog'
import { publishNarration } from './publishNarration'
import { recordVoiceTiming } from './voiceLatency'
import { initialVoiceState, voiceTransition } from './voiceOrchestratorTransition'

export function createVoiceOrchestrator(room) {
  let state = initialVoiceState()
  let pendingTimings = []
  const send = (event) => publishNarration(room, event)
  const watchdog = createVoiceWatchdog(send)

  function publish(event) {
    if (event.type === 'client_timing' && ['api_request_start', 'sse_start'].includes(event.name)) {
      recordVoiceTiming(event)
      pendingTimings.push(event)
      return
    }
    const transition = voiceTransition(state, event)
    transition.timings.forEach(recordVoiceTiming)
    transition.commands.forEach(send)
    if (transition.watch === 'stop') watchdog.stop()
    if (transition.watch === 'active') watchdog.active(transition.context)
    state = transition.state
    if (event.type === 'start') {
      pendingTimings.forEach((timing) => send({
        type: 'timing', name: timing.name, timestamp_ms: timing.timestamp_ms,
        run_id: event.run_id, attempt_id: event.attempt_id, sequence: event.sequence,
      }))
      pendingTimings = []
    }
    if (event.type === 'stream_settled') pendingTimings = []
  }

  function stop() {
    watchdog.stop()
    send({
      type: 'playback',
      action: 'stop',
      run_id: state.runId,
      attempt_id: state.attemptId,
      sequence: state.sequence,
    })
    state = initialVoiceState()
    pendingTimings = []
  }

  return { publish, stop }
}
